"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { createClient } from "@/lib/supabase/client";

export function PostHogProvider() {
  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!key) return;

    posthog.init(key, {
      api_host: "/a",
      ui_host: "https://eu.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: { password: true },
      },
      autocapture: true,
      capture_heatmaps: true,
      capture_exceptions: true,
      // Reduce fingerprinting signals that trigger Firefox ETP
      persistence: "localStorage+cookie",
      cross_subdomain_cookie: false,
      secure_cookie: true,
      loaded: (ph) => {
        // Identify the user if already logged in
        try {
          const supabase = createClient();
          supabase.auth
            .getUser()
            .then(({ data: { user } }) => {
              if (user) {
                ph.identify(user.id, { email: user.email });
              }
            })
            .catch(() => {});
        } catch {}
      },
    });

    // No cleanup needed — PostHog persists across the app lifecycle
  }, []);

  return null;
}
